export enum StrategySort {
    RecentlyCreated = "Recently created",
    OfferBalance = "Highest balance"
}
